export default __webpack_public_path__ + "19ba000069dc57b32236d7840d283eda.glb";